import React from "react";
import { Box, Typography } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import StyledCheckInbox from "./StyledCheckInbox";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { BUTTON_LABELS } from "../../constants/lang";
import { ROUTE_PATH } from "../../constants/route";

const CheckInbox = () => {
  const location = useLocation();
  const { data } = location.state || {};

  return (
    <StyledCheckInbox>
      <Box className="checkInbox-wrap">
        <Box className="checkInbox-header">
          <Box className="circleIcon">
            <EmailOutlinedIcon sx={{ fontSize: 30, color: "#A78D78" }} />
          </Box>
          <Box className="header">Check Your Inbox</Box>
        </Box>
        <Box className="body-wrap">
          <Typography className="body-text">
            A password reset link has been sent to your registered email{" "}
            <span>{data?.email}</span>. If you don't receive the
            email, check your spam folder and follow the steps.
          </Typography>

          <Typography className="rest-link">
            The reset link will expire in 30 minutes.
          </Typography>
        </Box>
        <Box className="backLogin">
          <Link to={ROUTE_PATH.LOGIN}>{BUTTON_LABELS.BACK_TO_LOGIN}</Link>
        </Box>
      </Box>
    </StyledCheckInbox>
  );
};

export default CheckInbox;
